// Signing defaults are client policy; admission limits belong to the connected database.
export const DEFAULT_PEER_JWT_LIFETIME_SECONDS = 86_400
